import { render } from "./BarChart3.vue?vue&type=template&id=48c884bf"
import script from "./BarChart3.vue?vue&type=script&lang=js"
export * from "./BarChart3.vue?vue&type=script&lang=js"

import "./BarChart3.vue?vue&type=style&index=0&id=48c884bf&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__